import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

import { HideableSubLayer } from '@/geoObjects/store/types';
import ModalWrapper from '@/shared/components/ModalWrapper.vue';
import Button from '@/shared/components/buttons/Button.vue';
import FormCheckbox from '@/shared/components/form/FormCheckbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalMapObjectsSubType',
  props: {
    visible: { type: Boolean },
    title: null,
    hideableSubLayers: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean; title: string; hideableSubLayers: HideableSubLayer[] }



// create a state from prop
const subLayerState = ref<HideableSubLayer[]>([]);

watch(
  () => props.hideableSubLayers,
  (newSubLayers) => {
    subLayerState.value = newSubLayers.map((layer) => ({ ...layer }));
  },
  { immediate: true },
);

/* COMPUTED */

const isAtLeastOneLayerHidden = computed<boolean>(() => subLayerState.value.some((layer) => layer.hidden));

/* METHODS */

function toggleSubLayerVisibility(index: number, checked: boolean) {
  subLayerState.value[index].hidden = !checked;
}

function toggleVisibility() {
  const layers = [...subLayerState.value];
  if (isAtLeastOneLayerHidden.value) {
    layers.forEach((layer) => {
      // eslint-disable-next-line no-param-reassign
      layer.hidden = false;
    });
  } else {
    layers.forEach((layer) => {
      // eslint-disable-next-line no-param-reassign
      layer.hidden = true;
    });
  }
  subLayerState.value = layers;
}

return { __sfc: true,props, subLayerState, isAtLeastOneLayerHidden, toggleSubLayerVisibility, toggleVisibility, ModalWrapper, Button, FormCheckbox }
}

})